<template>
  <div id='ae' class='' v-loading='loading'>
  
    <tyc :tqobj='tqobj'></tyc>

    <el-dialog class='gDia' :title="$t('app_pushDevice')" v-model="pushedList"  size='large'>
      <div id='' class=' '>
    
        <el-row>
          <el-col :span="10">
          
            <el-button :disabled="list.length == 0"  @click='mulDelAppPush()' style=''>{{$t('app_mulUnbind')}}</el-button>

            <el-button v-show="true" @click='refreshBind()' style=''>{{$t('lin_global.shuaxin')}}</el-button>

          </el-col>
          <el-col v-show='false' :offset="1" :span="4">
            <div class=''><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
          </el-col>
        </el-row>
      
        <el-table
        class='gTopMg'
        ref="multipleTable"
        id='dpTable'
        :data="tableData1"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
          <el-table-column
            
            type="selection"
            align='center'
            width="55">
          </el-table-column>
          <el-table-column
            
            prop="terminalName"
            align='center'
            :label="$t('app_deviceName')"
            width="">
          </el-table-column>
          <el-table-column
            align='center'
            prop="terminalNo"
            :label="$t('app_deviceNo')"
            width="">
          </el-table-column>
          <el-table-column
            prop="pushTime"
            align='center'
            :label="$t('app_pushTime')"
            width='175'>
          </el-table-column>
          <el-table-column
            align='center'
            prop="mechName"
            :label="$t('app_distributor')"
            width=''>
          </el-table-column>
          
          <el-table-column
            prop="operate"
            :label="$t('app_operate')"
            align='center'
            
            width='106'>
            <template slot-scope='scope'>
              
              <el-tooltip class="item" effect="dark" :content="$t('app_unbind')" placement="top">
                <el-button   @click='delAppPush(scope.row)' type=text><i class="fa fa-trash" style="color:#FF4949;"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
        
        <div class="gPgDiv">

          <el-pagination
          class='gPg'
          @current-change="pageSelect"
          @size-change="pageSized1"
          :current-page="page"
          :page-sizes='$gRows'
          
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <div class='gPageBorder'>
      <div style='width:140px;height:140px;margin:24px 24px 24px 24px;display:inline-block;float:left;overflow:hidden;'>
        <div :style="avtStyle">
          <!-- <img style='width:100%;' :src="imgFullUrl(config? config.data.appBigIcon : '')"> -->
        </div>
      </div><div style='display:inline-block;width:calc(100% - 188px);height:100%;margin-bottom:0px;:'>
        <div style='height:64px;'>
          <button class='dt-word-appmain' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.data.appName : ''}}</button>
        </div> 
        <div style='height:60px;'> 
          <table class='dt-app-app'>
            <tr>
              <td>
                <label class='dt-word-apptt'>{{$t('app_version')}}：</label>
                <label class='dt-word-appmain'>{{config? config.data.appVersion : ''}}</label>
              </td>
              <td>
                <label class='dt-word-apptt'>{{$t('app_verTag')}}：</label>
                <label class='dt-word-appmain'>{{config? config.data.versioncode : ''}}</label>
              </td>
              <td>
                <label class='dt-word-apptt'>{{$t('app_package')}}：</label>
                <label class='dt-word-appmain'>{{config? config.data.packagename : ''}}</label>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label class='dt-word-apptt'>{{$t('terminal.appBind.label_size')}}：</label>
                <label class='dt-word-appmain'>{{config? ((config.data.appSize/1024)/1024).toFixed(2) + 'MB' : ''}}</label>
              </td>
              <td>
                <label class='dt-word-apptt'>{{$t('app_appType')}}：</label>
                <label class='dt-word-appmain'>{{config? config.data.appCategoryName:''}}</label>
              </td>
              <td>
                <label class='dt-word-apptt'>{{$t('app_vStatus')}}：</label>
                <label class='dt-word-appmain'>{{config? vSt[config.data.appStatus] : ''}}</label>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
        <div style='min-height:60px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-apptt' style='display:inline-block;min-width:70px;'>
            {{$t('app_introl')}}：
          </div>
          <div class='dt-word-appmain' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{config?config.data.appDesc:''}}</pre>
          </div>
        </div>
      </div>
    </div>
     
    <div class='gPageBorder gTopMg' v-show='captures? captures.length > 0 : false'  style=''>
      
      <p class='gCtColor  gPTitle' style=''>{{$t('app_screenShot')}} </p>
      <div>
        <img onerror="this.src='/static/img/df-h.png'" v-for='item in captures' class='gBorder' style='width:180px;height:320px;margin:24px 0 24px 24px;border-radius:4px;' :src="imgFullUrl(item)">
      </div>
  
    </div>

    <div v-show='!dobj.isMk' class='gPageBorder gTopMg'  style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_hisVer')}} </p>

      <el-button :disabled="tableData? tableData.length == 0 : false"  @click='uploadNew' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_ulNew')}}</el-button>

      <!-- <el-button v-show='true' type='primary' @click='pushedList = true' style="margin-bottom:20px;margin-top:5px;">{{$t('app_pusheddvlist')}}</el-button> -->
      
      <el-table
        :data="tableData"
        border
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="appName"
          :label="$t('app_appName')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appVersion"
          width=''
          :label="$t('app_version')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appCategoryName"
          width=''
          :label="$t('app_type')">
        </el-table-column>
      
        <el-table-column
          header-align='center'
          align='center'
          :formatter="dateFormat"
          prop="createTime"
          width='170'
          :label="$t('app_ulTime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          :formatter="verifyFm"
          prop="createTime"
          width=''
          :label="$t('app_vStatus')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='118'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            

            <!-- <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2'" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->

            <!-- <el-button v-show="config.data.isoperation === 0" type=text @click='deleteAppHis(scope.row)'>{{$t('app_del')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' v-show="config.data.isoperation === 0" @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip> --> 


            <!-- <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
              <el-button v-show="scope.row.appStatus == 2" type=text @click='pushApp(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('app_down')" placement="top">
              <el-button v-show="scope.row.appStatus == 2" type='text' @click='downOldApp(scope.row)'><i class="fa fa-download" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0" type='text' @click='submitApp(scope.row)'><i class="fa fa-arrow-up" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button v-show='scope.row.isoperation === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button v-show='scope.row.isoperation === 0' type='text' @click='deleteApp(scope.row)'><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
    </div>
  

  </div>
</template>

<style>
  .dt-word-appmain{color:rgb(72,87,106)}
  .dt-word-apptt{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .dt-app-app{width:100%;height:100%;}
    .dt-app-app td{width:25%;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../assets/df.png'
  import tyc from '@/components/global/tyc'
  export default {
    data () {
      return {
        total: 0,
        queryKey: '',
        sNum:0,
        page:1,
        tableData1: [],
        tableData: [],
        list: [],
        pushedList: false,
        tqobj: '',
        dobj: '',
        vSt: '',
        config: '',
        captures: [],
        loading: 0,
        iconUrl: ''
      }
    },
    components: {
      tyc
    },
    computed: {
      avtStyle () {
        //this.config.data.appBigIcon
        var url =  this.iconUrl ? this.imgFullUrl(this.iconUrl) : require('../../assets/df.png')
        
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
      },
      showUploadNew () {
        
        if (this.config.data) {
          if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      pushApp (row) {
        // /task/ptask/new
        this.$router.push({path: '/task/ptask/new', query: {mode: 2, fname: row.appName, ftype: '7', fid: row.versionid}})
      },
      pageSized1 (val) {
        this.$gRow = val
        this.getBinds()
      },
      query () {

      },
      refreshBind () {
        this.getBinds()
      },
      handleSelectionChange (list) {
        this.sNum = list.length
        this.list = list
      },
      mulDelAppPush () {
        var title = this.$t('app_isUnbindApp')
        this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          //  console.log(this.list)
            var tNos = ''
            var pkg = this.config.data.packagename
            this.list.forEach((vl) => {
              tNos += vl.terminalNo + ','
            })
            tNos = tNos.substring(0, tNos.length - 1)
            // console.log(ids)
            if (!tNos) {
              this.$message($t('app_oneDeviceMust'))
              return 
            }
            this.appDelRqs(tNos, pkg)
        }, '')
      },
      appDelRqs (nos, pkg) {
        var ns = nos ? nos : ''
        var p = pkg ? pkg : ''
        console.log('unbf')
        this.$unbind(ns, this.config.data.appVersion, p, (res) => {
          this.loading = 0
          this.$message(res.message)
          if (res.status === 200) {
            
            this.getBinds()
          }
        }, () => {
          this.loading = 0
        })
      },
      delAppPush (row) {
        var title = this.$t('app_isUnbindApp')
       
        this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
           
           this.appDelRqs(row.terminalNo, this.config.data.packagename)
        }, '')
      },
      getBinds () {
        var id = this.config.data.appdevid
        if (!id) return
        this.loading = 1
        this.$pushedTerList(this.page, this.$gRow, id, (res) => {
          this.loading = 0
          if (res.status === 200) {
            console.log(res)
            this.tableData1 = res.data
            this.total = res.total
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      },
      allUnbind () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var tNos = ''
          this.list.forEach((vl) => {
            tNos += vl.terminalNo + ','
            
          })
          tNos = tNos.substring(0, tNos.length - 1)
          // console.log(ids)
          if (!tNos) {
            this.$message($t('app_oneDeviceMust'))
            return 
          }
          this.unbindReq(tNos, this.detail.packageName)
        }, '')
        
      },
      downOldApp (row) {
        window.open(this.$host + row.appUrl)
		// let base_url = "http://218.17.164.125:8686"
        // window.open(base_url + row.appUrl)
      },
      deleteApp (obj) {
        this.$showConfirm(
          this.$t("app_tip"),
          this.$t("app_tipMkDel"),
          this.$t("app_sure"),
          this.$t("app_cancel"),
          "warning",
          () => {
            // console.log(obj)
            this.$deleteAppHis(obj.versionid, res => {
                if (res.status === 200) {
                  // this.getAppHistory()
                  if (this.config.data.appVersion == obj.appVersion) {
                    this.$message.success(res.message)
                    this.$router.replace({path: '/appList'})
                  }
                  this.getDetail()
                } else {
                  this.$message(res.message);
                }
              },
              ""
            );
          },
          ""
        );
      },
      submitApp (obj) {

        this.$showConfirm(
          this.$t("app_tip"),
          this.$t("app_tipVerify"),
          this.$t("app_sure"),
          this.$t("app_cancel"),
          "warning",
          () => {
            this.loading = 1;
            this.$submitVerifyApp1(
              obj.applicationid,
              res => {
                this.loading = 0;
                if (res.status === 200) {
                  // this.getAppHistory()
                  this.getDetail()
                } else {
                  this.$message.error(res.message);
                }
              },
              () => {
                this.loading = 0;
              }
            );
          },
          ""
        );
      },
      verifyFm (row) {
        console.log('row', row.appStatus, this.vSt)
        return this.vSt[row.appStatus]
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteAppHis(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          }).catch(() => {
          })
        }
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },

      getAppHistory () {
        if (!this.config.data.appName) {
          return
        }
        // console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
            //console.log('his', res)
            //alert(res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          var mech = this.dobj.mech
          this.$getAppHistory1(mech, this.config.data.packagename, (res) => {

            console.log('his', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // /newversion 
        //this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
        
        this.$setWObj("appUlNew", this.config );
        this.$router.push({path: '/applist/newversion'})
      },
      
      getDetail () {
        // this.config 
        
        if (this.dobj.isMk) {
          this.loading = 1
          this.$appMkDetail(this.dobj.appid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              // this.tableData = res.data
              this.config = {data: res.data}
              this.iconUrl = this.config.data.appBigIcon
              this.setCapturesArr(this.config.data.appScreenShot)
              // this.getAppHistory()
              // this.getBinds()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.loading = 1
          this.$appDetail(this.dobj.appid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              // this.tableData = res.data
              this.config = {data: res.data}
              this.iconUrl = this.config.data.appBigIcon
              this.setCapturesArr(this.config.data.appScreenShot)
              this.getAppHistory()
              this.getBinds()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
        
        
        
      },
      setCapturesArr (strs) {
        if (strs) {
          var arr = strs.split(',')
          this.captures = arr
        }
      }
    },
    mounted () {
    
      var _this = this
      this.tqobj = {
        keys: ['appVSt'],
        callback: (datas) => {
          this.vSt = datas[0]
        }
      }

      this.dobj = this.$getWObj().appDisplay

      this.getDetail()



      
    }
  }
</script>



// WEBPACK FOOTER //
// appDisplay.vue?3171488d